import { useEffect, useState } from 'react'

import styled from 'styled-components'
import { useSearchParams } from 'react-router-dom'
import { selectIsJoinTeamModalOpen } from 'features/common/model/selectors/appSelectors'
import { setIsCreateTeamModalOpen, setIsJoinTeamModalOpen } from 'features/common/model/slice/appSlice'
import { useAppDispatch, useAppSelector } from 'shared/config/store'
import { Alert, Button, Form, FormProps, Modal, Typography } from 'shared/ui'
import { userSelector } from 'features/user/model/selectors/userSelectors'
import { NOTIFICATION_TYPES, showNotification } from 'features/common/notifications'

import { joinToFamilyCloudThunk, leaveFromFamilyCloudThunk } from '../model/slice/teamSlice'
import { familySelector } from '../model/selectors/teamSelectors'
import { INVITE_HASH_PARAM_NAME, removeParamFromURL } from '../../../shared/utils/urlUtils'

type FieldType = {
  teamName: string
}

export const JoinTeamModal = () => {
  const dispatch = useAppDispatch()
  const isJoinTeamModalOpen = useAppSelector(selectIsJoinTeamModalOpen)
  const familyCloud = useAppSelector(familySelector)
  const teamName = familyCloud?.name
  const { Title } = Typography
  const userData = useAppSelector(userSelector)
  const [searchParams] = useSearchParams()
  const alertMessage = `You're already part of “${teamName}”. To switch teams, leave your current one first.`
  const [isJoinTeamBtnDisabled, setIsJoinTeamBtnDisabled] = useState(true)
  const inviteHash = searchParams.get(INVITE_HASH_PARAM_NAME)
  const isUserPartOfTeam = !!userData?.family_user_id


  useEffect(() => {
    setIsJoinTeamBtnDisabled(isUserPartOfTeam)
  }, [isUserPartOfTeam])

  const handleClose = () => {
    dispatch(setIsJoinTeamModalOpen(false))
    removeParamFromURL(INVITE_HASH_PARAM_NAME)

    if(!isUserPartOfTeam) {
      dispatch(setIsCreateTeamModalOpen(true))
    }
  }

  const handleJoin = () => {
    const successCallback = () => {
      handleClose()
      window.location.href = '/dashboard/all-assets'
    }

    const errorCallback = () => {
      errorMessage: 'Failed to join team'
    }

    dispatch(joinToFamilyCloudThunk({ fchash: inviteHash, successCallback, errorCallback }))
  }

  const handleFinish: FormProps<FieldType>['onFinish'] = () => {
    if(userData?.family_user_id) {
      if(userData?.is_owner_family) {
        showNotification({
          type: NOTIFICATION_TYPES.WARNING,
          title: 'Something going wrong ',
          message: `Can't join the team. Please contact support team.`,
        })

        return
      }

      dispatch(leaveFromFamilyCloudThunk({ userId: userData?.id?.toString(), callback: handleJoin }))
      return
    }

    handleJoin()
  }


  const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }

  return (
    <Modal open={isJoinTeamModalOpen}
      footer={null}
      width={480}
      closable={false}
      destroyOnClose={true}
    >
      <SModalTitle>
        <Title>
          Join team
        </Title>
      </SModalTitle>

      <SModalImg>
        <img
          alt="team"
          height={88}
          width={88}
          src="/image.png"
        />
      </SModalImg>

      <SContentContainer>
        <Form layout="vertical"
          onFinish={handleFinish}
          onFinishFailed={onFinishFailed}
          preserve={false}
          requiredMark="optional"
        >
          <Form.Item>
            <Button block
              type="primary"
              htmlType="submit"
              disabled={isJoinTeamBtnDisabled}
            >
              Join team
            </Button>
          </Form.Item>

          <Form.Item>
            <Button block
              danger
              onClick={handleClose}
            >
              Decline
            </Button>
          </Form.Item>
        </Form>

        {userData?.family_user_id && (
          <Alert
            message={alertMessage}
            type="info"
            showIcon
          />
        )}

      </SContentContainer>
    </Modal>
  )
}

const SContentContainer = styled.div``

const SModalTitle = styled.div`
  text-align: center
`
const SModalImg = styled.div`
  text-align: center;
  margin-bottom: 24px;
`
const SModalText = styled.div`
  text-align: center;
  margin: 16px 0 32px 0;
`

